import React, { useState, useEffect } from 'react';
import { useMobile } from '../hooks/useMobile';
import { useAuthContext } from '../contexts/Auth';
import { useLinesContext } from '../contexts/Lines';
import { useCompanyContext } from '../contexts/Company';
import { fetcher } from '../components/API/API';
import { getProducts } from '../components/API/product';
import { getApplicationBasics } from '../components/API/application';
import { addIsSellingAttrToLines, pathname } from '../utils';
import Layout from '../components/lines/Layout';
import LinesNotSupportedMobilePage from '../components/Mobile/LinesNotSupportedMobilePage';

export default function Lines() {
  const mobile = useMobile('sm');

  const { signedIn } = useAuthContext();
  const [loadingColor, setLoadingColor] = useState('');
  const [loadingText, setLoadingText] = useState('');
  const [loadingTextColor, setLoadingTextColor] = useState('');
  const [loadingSpinnerColor, setLoadingSpinnerColor] = useState('');

  const {
    setLoading,
    lines,
    setLines,
    products,
    setProducts,
    applications,
    setApplications,
  } = useLinesContext();
  const { business, getUserCompany } = useCompanyContext();

  function setCustomLoadingIndicator() {
    setLoadingText(`Loading ${pathname.lines.label}`);
    setLoadingTextColor('black');
    setLoadingColor('white');
    setLoadingSpinnerColor('dark');
  }

  function setLoadingIndicator() {
    setLoadingText('');
    setLoadingTextColor('');
    setLoadingColor('');
    setLoadingSpinnerColor('');
  }

  async function getLines() {
    const lines = await fetcher('/v1/lines').catch(() => []);
    setLines(addIsSellingAttrToLines(lines));
  }

  async function getProductsWrapper() {
    try {
      const products = await getProducts();
      setProducts(products);
    } catch (error) {
      setProducts([]);
    }
  }
  async function getApplicationsWrapper() {
    try {
      const applications = await getApplicationBasics();
      setApplications(applications);
    } catch (error) {
      setApplications([]);
    }
  }

  async function getData() {
    const dataRequests = [];
    if (!lines) {
      dataRequests.push(getLines());
    }
    if (!products) {
      dataRequests.push(getProductsWrapper());
    }
    if (!applications) {
      dataRequests.push(getApplicationsWrapper());
    }
    if (!business) {
      dataRequests.push(getUserCompany());
    }
    if (dataRequests.length > 0) {
      setCustomLoadingIndicator();
      setLoading(true);
      await Promise.all(dataRequests);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!signedIn) return;
    if (!lines || !products || !applications || !business) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn]);

  useEffect(() => {
    if (lines && products && applications && business) {
      setLoadingIndicator();
    }
  }, [lines, products, applications, business]);

  return (
    <React.Fragment>
      {!signedIn && <div />}
      {signedIn && (
        <React.Fragment>
          {mobile && <LinesNotSupportedMobilePage />}
          {!mobile && (
            <Layout
              loadingColor={loadingColor}
              loadingText={loadingText}
              loadingTextColor={loadingTextColor}
              loadingSpinnerColor={loadingSpinnerColor}
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
